import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import journeyService from './journeyService'

const initialState = {
    journeys: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
    actionType: 'get',
}

export const createJourney = createAsyncThunk('journeys/create', async (journeyData, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await journeyService.createJourney(journeyData, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const editJourney = createAsyncThunk('journeys/edit', async (journeyData, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await journeyService.editJourney(journeyData, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const duplicateJourney = createAsyncThunk('journeys/duplicate', async (journeyData, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await journeyService.duplicateJourney(journeyData, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const getJourneys = createAsyncThunk('journeys/getAll', async (_, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await journeyService.getJourneys(token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const deleteJourney = createAsyncThunk('journeys/delete', async (id, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await journeyService.deleteJourney(id, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const journeySlice = createSlice({
    name: 'journey',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(createJourney.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
                state.actionType = 'create'
            })
            .addCase(createJourney.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.journeys.push(action.payload)
            })
            .addCase(createJourney.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(editJourney.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
                state.actionType = 'edit'
            })
            .addCase(editJourney.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.journeys = state.journeys.filter(
                    (journey) => journey._id !== action.payload.updatedJourney._id
                )
                state.journeys.push(action.payload.updatedJourney)
            })
            .addCase(editJourney.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(duplicateJourney.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
                state.actionType = 'duplicate'
            })
            .addCase(duplicateJourney.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.journeys.push(action.payload.duplicatedJourney)
            })
            .addCase(duplicateJourney.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(getJourneys.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
                state.actionType = 'get'
            })
            .addCase(getJourneys.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.journeys = action.payload
            })
            .addCase(getJourneys.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload

                console.log('ERROR')
            })

            .addCase(deleteJourney.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
                state.actionType = 'delete'
            })
            .addCase(deleteJourney.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.journeys = state.journeys.filter(
                    (journey) => journey._id !== action.payload.id
                )
            })
            .addCase(deleteJourney.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = journeySlice.actions
export default journeySlice.reducer